import {
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';

const ConfirmAsyncActionModalContent = ({
  onClose,
  asyncAction,
  headerText = 'Confirm Action',
  bodyText,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await asyncAction();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ModalContent>
        <ModalHeader>{headerText}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{bodyText}</Text>
        </ModalBody>
        <ModalFooter justifyContent="left">
          <Button onClick={onClose} mr={3} isDisabled={isLoading}>
            {cancelButtonText}
          </Button>
          <Button
            backgroundColor="brand.primary"
            color="brand.white"
            onClick={handleConfirm}
            isLoading={isLoading}
          >
            {confirmButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </>
  );
};

export default ConfirmAsyncActionModalContent;
